import {
  ERROR_CODES,
  GRANT_TYPE_REFRESH_TOKEN,
  HTTP_METHODS,
} from './constants';
import axios from 'axios';
import { notification } from 'antd';
import { getAccessToken } from '../store/requests/auth';
import { PAGE_URLS } from './endpoints';

class Requester {
  constructor() {
    this.axios = axios.create({
      withCredentials: true,
    });
    this.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
          const { origin } = window.location;
          getAccessToken(undefined, GRANT_TYPE_REFRESH_TOKEN, origin)
            .then(() => window.location.replace(PAGE_URLS.DASHBOARD))
            .catch(() => window.location.replace(PAGE_URLS.LOGIN));
        } else {
          console.log(error);
          if (
            error?.response?.data?.errorCode !== ERROR_CODES.GRDR_1006 &&
            error?.response?.data?.errorCode !== ERROR_CODES.GRDR_1007 &&
            error?.response?.data?.errorCode !== ERROR_CODES.GRDR_1008 &&
            error?.response?.data?.errorCode !== ERROR_CODES.GRDR_1009 &&
            error?.response?.data?.code !==
              ERROR_CODES.SLOT_TEMPLATE_RELATED_WITH_ZONE_EXCEPTION &&
            error?.response?.data?.code !==
              ERROR_CODES.PROGRESS_PAYMENT_TEMPLATE_MAIN_ALREADY_EXISTS_EXCEPTION &&
            error?.response?.data?.code !==
              ERROR_CODES.ORDER_TRANSFER_EXCEPTION &&
            error?.response?.data?.code !==
              ERROR_CODES.PROGRESS_PAYMENT_TEMPLATE_MAIN_DELETE_EXCEPTION
          ) {
            this.notificationError('error', error?.response?.data?.message);
          }
        }
        return Promise.reject(error?.response);
      },
    );
  }

  notificationError = (type, message) => {
    notification[type]({
      message: 'Error',
      description: message,
    });
  };

  submit = async ({
    method = HTTP_METHODS.GET,
    url,
    params,
    data,
    options,
  }) => {
    try {
      const response = await this.axios({
        method,
        url,
        params,
        data,
        headers: {
          'Accept-Language': 'tr-TR',
        },
        ...options,
      });
      return Promise.resolve(response?.data);
    } catch (e) {
      return Promise.reject(e?.data);
    }
  };
}

export default new Requester();
